module.exports = __webpack_public_path__ + "img/LUB00403.0510177c.png";